export default __webpack_public_path__ + "static/anelson-99968ad6ab01013e3d8db5ee7c668d58.jpg";